import { Box, CircularProgress, CircularProgressProps, Typography } from "@material-ui/core";

interface DeletionCountDownProps {
	seconds: number;
}

const DeletionCountDown: React.FC<DeletionCountDownProps & CircularProgressProps> = ({ seconds, ...props }) => {
	return (
		<Box position="relative" display="inline-flex">
			<CircularProgress size="20px" variant="determinate" {...props} value={-seconds * 20} thickness={5} />
			<Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
				<Typography style={{ fontSize: 12 }} component="div" color="primary">
					{seconds}
				</Typography>
			</Box>
		</Box>
	);
};

export default DeletionCountDown;
